import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { AuthUserData, UserType } from '../../models/user';

interface AuthState {
  token: string | null;
  user: AuthUserData;
}

const dummyUser: AuthUserData = {
  id: '',
  username: 'user',
  type: UserType.COMMON,
  email: 'info@avantti.io',
  phone_number: '',
  user_businesses: [],
  user_events: [],
  photo_url: 'https://via.placeholder.com/40',
};

const initialState: AuthState = {
  token: null,
  user: dummyUser,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<{ user: AuthUserData; token: string }>) => {
      const { user, token } = action.payload;
      Cookies.set('token', token);
      Cookies.set('userData', JSON.stringify(user));
      return { ...state, user, token };
    },
    updateToken: (state, action: PayloadAction<string>) => {
      Cookies.set('token', action.payload);
      return { ...state, token: action.payload };
    },
    logout: (state) => {
      Cookies.remove('token');
      Cookies.remove('userData');
      Cookies.remove('selectedBusiness');
      Cookies.remove('selectedBusinessId');
      Cookies.remove('selectedEvent');
      return { ...state, user: dummyUser, token: null };
    },
    loadAuth: (state) => {
      const user: AuthUserData = JSON.parse(Cookies.get('userData') || '{}');
      const token = Cookies.get('token');
      if (user && token) {
        return { ...state, user, token };
      }
      return state;
    },
  },
});

export const {
  logout, loginSuccess, loadAuth, updateToken,
} = authSlice.actions;

export const authReducer = authSlice.reducer;
